
import './App.css';
import './css/Colors.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Profile from './views/Profile.js';
import Religion from './views/Religion.js';
import Personal from './views/Personal.js';
import Qualification from './views/Qualification.js';
import Verify from './views/Verify.js';
import Login from './views/login.js';
import Viewpage from './views/Viewpage.js';
import Customerdetails from './views/Customerdetails.js';
import Filter from './views/Filter.js';
import Popup from './views/Popup.js';
import Editprofile from './views/Editprofile.js';
import PasswordEncrypt from './PasswordEncryption.js';
import ImageUpload from './views/ImageUpload.js';
import Place_screen from './views/Placescreen.js';
import Basic from './views/Basic_details.js';
import Religion_details from './views/Religion_details.js';
import Groom from './views/Groom_location.js';
import Professional from './views/Professional_details.js';
import Family_details from './views/Family_details';
import Accountexist from './views/Accountexist.js';
import Resetpassword from './views/Resetpassword.js';
import Forgotpassword from './views/Forgotpassword.js';
import Enterotp from './views/Enterotp.js';
import Dashboard from './views/Dashboard.js';
import Verify_member from './views/Verify_member.js';
import Documentpopup from './views/Documentpopup.js';
import Interestpage from './views/Interestpage.js';
import DocumentUpload from './views/Documentupload.js';
import Adminlogin from './views/Adminlogin.js';
import Notification from './views/Notification.js';
import Report from './views/Report.js';
import Reportcount from './views/Reportcount.js';
import Searchpage from './views/Searchpage.js';
import HomeList from './views/HomeList.js';
import Numberotp from './views/Numberotp.js';
import Numberpopup from './views/Mobileverifypopup.js';
import DocumentUploadManualy from './views/Documentverifymanualy.js';
import Settingspage from './views/Settingspage.js';
import NumberEditpopup from './views/NumberEditpopup.js';
import EmailEditpopup from './views/EmailEditpopup.js';
import ContactOtpscreen from './views/ContactOtpscreen.js';
import PrivacyPolicy from './views/PrivacyPolicy.js';
import TermsAndConditions from './views/TermsAndConditions.js';
import Changepassword from './views/Changepassword.js';
import Payment from './views/Payment.js';
import UpgradePage from './views/UpgradePage.js';
import ChatInit from './views/chat/ChatInit.js';
import Offeradd from './views/Offeradd.js';
import { notificationListener } from "./utils/notificationListener";
import { useEffect } from "react";
import Loginviaotp from './views/Loginviaotp.js';
import ForgotpasswordOTP from './views/ForgotpasswordOTP.js';
import BirthChart from './views/BirthChart.js';
import ReportChart from './views/Reportchart.js';









function App() {


  useEffect(() => {
    notificationListener();
  }, []);

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <Router onContextMenu={disableRightClick}>
      <ToastContainer />

      <Routes>
        <Route path="/" element={<Profile />} />
        <Route path="/Religion" element={<Religion />} />
        <Route path="/Personal" element={<Personal />} />
        <Route path="/Qualification" element={<Qualification />} />
        <Route path="/Verify" element={<Verify />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Viewpage" element={<Viewpage />} />
        <Route path="/Customerdetails" element={<Customerdetails />} />
        <Route path="/Filter" element={<Filter />} />
        <Route path="/Popup" element={<Popup />} />
        <Route path="/Editprofile" element={<Editprofile />} />
        <Route path="/PasswordEncrypt" element={<PasswordEncrypt />} />
        <Route path='/ImageUpload' element={<ImageUpload />} />
        <Route path='/place_screen' element={<Place_screen />} />
        <Route path='/Basic_details' element={<Basic />} />
        <Route path='/Religion_details' element={<Religion_details />} />
        <Route path='/Groom_location' element={<Groom />} />
        <Route path='/Professional_details' element={<Professional />} />
        <Route path='/Family_details' element={<Family_details />} />
        <Route path='/Accountexist' element={<Accountexist />} />
        <Route path='/Resetpassword' element={<Resetpassword />} />
        <Route path='/Forgotpassword' element={<Forgotpassword />} />
        <Route path='/Enterotp' element={<Enterotp />} />
        <Route path='/Dashboard' element={<Dashboard />} />
        <Route path='/Verify_member' element={<Verify_member />} />
        <Route path='/Documentupload' element={<DocumentUpload />} />
        <Route path='/Documentpopup' element={<Documentpopup />} />
        <Route path='/Interestpage' element={<Interestpage />} />
        <Route path='/Adminlogin' element={<Adminlogin />} />
        <Route path='/Notification' element={<Notification />} />
        <Route path='/Report' element={<Report />} />
        <Route path='/Reportcount' element={<Reportcount />} />
        <Route path='/Searchpage' element={<Searchpage />} />
        <Route path='/HomeList' element={<HomeList />} />
        <Route path='/Numberotp' element={<Numberotp />} />
        <Route path='/Numberpopup' element={<Numberpopup />} />
        <Route path='/DocumentUploadManualy' element={<DocumentUploadManualy />} />
        <Route path='/Settingspage' element={<Settingspage />} />
        <Route path='/NumberEditpopup' element={<NumberEditpopup />} />
        <Route path='/EmailEditpopup' element={<EmailEditpopup />} />
        <Route path='/ContactOtpscreen' element={<ContactOtpscreen />} />
        <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
        <Route path='/TermsAndConditions' element={<TermsAndConditions />} />
        <Route path='/Changepassword' element={<Changepassword />} />
        <Route path='/Payment' element={<Payment />} />
        <Route path='/Upgrade' element={<UpgradePage />} />
        <Route path='/ChatInitiate' element={<ChatInit />} />
        <Route path='/Offeradd' element={<Offeradd />} />
        <Route path='/Loginviaotp' element={<Loginviaotp />} />
        <Route path='/ForgotpasswordOTP' element={<ForgotpasswordOTP />} />
        <Route path='/BirthChart' element={<BirthChart />} />
        <Route path='/Reportchart' element={<ReportChart />} />

      </Routes>
    </Router>
  );
}

export default App;
